import React from 'react';
import { Detector } from 'react-detect-offline';
import { useSnackbar } from '../Snackbar/snackBarProvider';
import PropTypes from 'prop-types';

const CheckConnection = ({ onCheck, errorMsg, displaySnackbar = true}) => {
  const { snackbarOpen } = useSnackbar();

  return (
    <Detector
      render={({ online}) => {
        // Pass the connection status to the onCheck callback
        if (onCheck) {
          onCheck(online);
        }

        // Trigger snackbar if offline
        if (!online && displaySnackbar) {
          snackbarOpen(`${errorMsg}`, '');
        }
      }}
    />
  );
};

CheckConnection.propTypes = {
  onCheck: PropTypes.func,
  errorMsg: PropTypes.string,
  displaySnackbar: PropTypes.bool,

};

export default CheckConnection;
